import { render } from "./LovsManagementFixedLovsTable.vue?vue&type=template&id=711d8cc1&scoped=true&ts=true"
import script from "./LovsManagementFixedLovsTable.vue?vue&type=script&lang=ts"
export * from "./LovsManagementFixedLovsTable.vue?vue&type=script&lang=ts"

import "./LovsManagementFixedLovsTable.vue?vue&type=style&index=0&id=711d8cc1&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-711d8cc1"]])

export default __exports__